var render, staticRenderFns
import script from "./ContentBackground.vue?vue&type=script&lang=tsx"
export * from "./ContentBackground.vue?vue&type=script&lang=tsx"
import style0 from "./ContentBackground.vue?vue&type=style&index=0&id=07dbfd00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dbfd00",
  null
  
)

export default component.exports